import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SFbanner from "../Page-section/sales-funnel/SFbanner";
import SFprocess from "../Page-section/sales-funnel/SFprocess";
import { useSEO } from "../hooks/useSEO";

function SalesFunnel() {
  useSEO({
    title:
      "Sales Funnel Optimization | Get More Leads & Sales Fast",
    description:
      "Grow your business faster with our sales funnel optimization services. Get 3X more conversions, better leads, and higher ROI with proven strategies.",
    canonical: "https://empowerweb.in/sales-funnel-optimization",
    ogTitle: "Sales Funnel Optimization | conversion funnel optimization",
    ogDescription:
      "Improve your sales funnel at every stage. Expert optimization for higher conversions and revenue.",
    keywords:
      "sales funnel optimization ,conversion funnel optimization,  lead generation funnels, sales funnel services",
  });
  return (
    <div>
      <Header />
      <Navbar />
      <main>
        <SFbanner />
        <SFprocess />
      </main>
      <Footer />
      
    </div>
  );
}

export default SalesFunnel;
